import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { ARTICLES as DEFAULT_ARTICLES } from "../data/articles";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";

export default function Conseils() {
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(null);
  const [ARTICLES, setARTICLES] = useState(DEFAULT_ARTICLES);

  useEffect(() => {
    api.get("/articles").then((r) => {
      if (r.data?.length) setARTICLES(r.data);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const slug = searchParams.get("article");
    if (slug) {
      const found = ARTICLES.find((a) => a.slug === slug);
      if (found) setOpen(found);
    }
  }, [searchParams]);

  return (
    <>
      <PageHeader
        eyebrow="Conseils immobiliers"
        title="Comprendre le marché avant de décider."
        sub="Nos analyses et conseils pour acheter, vendre ou investir sereinement sur la Côte d'Azur."
      />

      <section data-testid="conseils-page" className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16 lg:py-24">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.06}>
              <button
                type="button"
                onClick={() => setOpen(a)}
                data-testid={`article-card-${a.slug}`}
                className="group block h-full text-left"
              >
                <div className="h-52 overflow-hidden rounded-2xl">
                  <img
                    src={a.image}
                    alt={a.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="mt-5">
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-terracotta">
                    {a.category} · {a.readTime}
                  </span>
                  <h2 className="mt-2 font-serif text-xl font-semibold leading-snug text-azur transition-colors duration-300 group-hover:text-terracotta">
                    {a.title}
                  </h2>
                  <p className="mt-2 text-sm font-light leading-relaxed text-slate-600">{a.excerpt}</p>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-2xl" data-testid="article-modal">
          {open && (
            <div className="max-h-[80vh] overflow-y-auto pr-1">
              <div className="h-56 overflow-hidden rounded-xl">
                <img src={open.image} alt={open.title} className="h-full w-full object-cover" />
              </div>
              <DialogHeader className="mt-6">
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-terracotta">
                  {open.category} · {open.readTime} de lecture
                </span>
                <DialogTitle className="font-serif text-2xl font-semibold text-azur">{open.title}</DialogTitle>
              </DialogHeader>
              <div className="mt-4 space-y-4">
                {open.body.split("\n\n").map((p, i) => (
                  <p key={i} className="text-sm font-light leading-relaxed text-slate-600 sm:text-base">
                    {p}
                  </p>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
